import styled from 'styled-components'
import { em } from 'polished'
import { Text } from 'shared/Typography'

export const Content = styled.article`
  display: flex;
  flex-direction: column;
  gap: ${em(10)};

  ${p => p.theme.mq.upLg} {
    max-width: 80%;
    gap: ${em(30)};
  }
`

export const Prices = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${em(5)};
  margin-top: ${em(20)};

  ${p => p.theme.mq.upLg} {
    gap: ${em(5)};
  }
`

export const Price = styled.div`
  margin-bottom: ${em(20)};
`

export const OldPrice = styled.div`
  display: flex;
  align-items: center;
  gap: ${em(10)};
`

export const DiscountBadge = styled(Text)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${em(25.5)};
  padding: 0 ${em(5)};
  background-color: var(--color-P50);
  border-radius: ${em(4)};
`
